import { useEffect, useRef } from 'react'

import { getLookupQuestionDefault, isLookupQuestionDefault } from './tools.helpers'

/**
 * A question nobody has written by hand follows the entity type, so picking Vehicle swaps the
 * medicine wording for the vehicle one. Anything typed by the admin is left alone.
 */
export const SeedLookupQuestionWhenEntityChanges = ({ entityType, question, setFieldValue }) => {
  const previousEntityType = useRef(entityType)
  useEffect(() => {
    if (previousEntityType.current !== entityType && isLookupQuestionDefault(question)) {
      setFieldValue('lookup_question', getLookupQuestionDefault(entityType), false)
    }
    previousEntityType.current = entityType
  }, [entityType])

  return null
}
